export const focusNextElement = (currentTarget: HTMLElement) => {
  const form = currentTarget.closest("form");
  if (!form) return;

  const focusableElements = Array.from(
    form.querySelectorAll<HTMLElement>(
      'input, select, textarea, button, [tabindex]:not([tabindex="-1"])',
    ),
  ).filter(
    (el) =>
      !el.hasAttribute("disabled") &&
      el.getAttribute("tabindex") !== "-1" &&
      el.offsetParent !== null,
  );

  const index = focusableElements.indexOf(
    document.activeElement as HTMLElement,
  );
  const next = focusableElements[index + 1];
  next?.focus();
};
